import leadContainer from './LeadContainer.directive';

leadPopupRoutesConfig.$inject = ['$stateProvider'];

export function leadPopupRoutesConfig($stateProvider) {
  $stateProvider
    .state('leadpopup', {
      url: '/leadpopup',
      template: `<div ${leadContainer.htmlName}></div><ui-view/>`,
    })
    .state('leadpopup.view', {
      url: '/view/:id',
    });
}
